import React from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

export const AccountsView = ({
  goToPlaid,
  goToNextPage,
}: {
  goToPlaid: () => void;
  goToNextPage: () => void;
}) => (
  <div className="flex flex-col h-fit w-full gap-y-f2">
    <span className="text-main">
      Fragment uses Plaid to connect your verify and connect your bank accounts.
    </span>
    <span className="text-main-500">
      When you click the button below, you will be taken to the account
      verification flow in Plaid.
    </span>
    <PrimaryButtonV2
      onClick={() => {
        goToNextPage();
      }}
    >
      Connect Accounts
    </PrimaryButtonV2>
  </div>
);
